import { render } from "./FormattedQuery.vue?vue&type=template&id=8bf41cd4&scoped=true"
import script from "./FormattedQuery.vue?vue&type=script&lang=js"
export * from "./FormattedQuery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf41cd4"]])

export default __exports__